import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const BASE_URL = '/v1/settings/general/states'

const endpointsStates = {
  CREATE: BASE_URL,
  LOAD: (filter, sort, limit, skip) =>
    `${BASE_URL}/${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  LOAD_BY_ID: (id) => `${BASE_URL}/${id}`,
}

export default endpointsStates
